import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
//import { InterventionsPdfService } from '@app/services/interventions-pdf.service';
import { InterventionsService } from '@app/shared/services/entities/interventions.service';
//import { InterventionsTrayComponent } from '../interventions-tray/interventions-tray.component';
import { StockService } from '@app/shared/services/entities/stock.service';
//import { RecordsService } from '@app/shared/services/entities/records.service';
import { UsersService } from '@app/shared/services/entities/users.service';
import { Observable, map, startWith } from 'rxjs';
import { SimplePdfService } from '@app/shared/services/simple-pdf.service';
import { SimplePdfModel } from '@app/shared/models/simple-pdf.model';
import { LOGO_TECHMEDEVOLUTION, LOGO_THECLINIC } from './logo-constants';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('INTERVENTION CONSUMPTION DIALOG COMPONENT');

 interface ReporteCxData {
    unidadMedica: string;
    fechaSolicitud: string;
    nombrePaciente: string;
    diagnostico: string;
    aseguradora: string;
    fechaCx: string;
    procedimiento: string;
    folio: string;
    edad: string;
    especialidad: string;
    horaInicio: string;
    horaTermino: string;
    items: ReporteCxItem[];
    medico: string;
    tecnico: string;
  }

  interface ReporteCxItem {
    CODIGO: string;
    DESCRIPCION: string;
    'CANT.SOL': number | string;
    'INS.UTIL': number | string;
    PRECIO: string;
  }

import { isValidRfidTag, rfidTagValidators, RFID_TAG_ERROR } from '@app/shared/utils/rfid';
@Component({
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
],
  selector: 'app-interventions-consumption-dialog',
  templateUrl: './interventions-consumption-dialog.component.html',
  styleUrls: ['./interventions-consumption-dialog.component.scss']
})
export class InterventionsConsumptionDialogComponent implements OnInit {

  private logoEmpresaBase64: string = '';
  private logoClinicaBase64: string = '';

  public interventionForm: FormGroup;
  public tagRfidForm: FormGroup;
  public userWarehouse = null;
  public userCustomParams = null;
  public contractItem = null;
  public contract = null;
  public record = null;
  public doctorObject = null;
  public hospitalObject = null;
  public operationRoomObject = null;
  public patientObject = null;
  public placesObject = null;
  public procedureObject = null;
  public productObject = null;
  public specialtyObject = null;
  public userObject = null;
  public warehousesObject = null;
  public contratList = [];
  public medicalSupplySpecialistList = [];
  public itemList = [];
  public placesList = [];
  public productList = [];
  public warehousesList = [];
  public supplierList = [];
  public technicalSpecialistList = [];
  public consumption = [];
  public refund = [];

  public dataSource = null;
  public displayedColumns = ['itemNumber', 'itemDescription', 'quantity', 'delivery', 'consumption', 'refund', 'comment', 'actions'];

  public categoryTables: { key: string; label: string; dataSource: MatTableDataSource<any> }[] = [];
  public categoryColumns = ['itemCode', 'itemDescription', 'quantity', 'delivery', 'consumption', 'refund', 'type'];
  public categoryLabels: { [key: string]: string } = {
    products:      'Insumos',
    equipments:    'Equipos',
    medicines:     'Medicamentos',
    instrumentals: 'Instrumental'
  };

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<InterventionsConsumptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customMessageService: CustomMessageService,
    private inventoryService: StockService,
    private interventionsService: InterventionsService,
    private simplePdfService: SimplePdfService,
    private usersService: UsersService,
    public dialog: MatDialog
  ) { }

  async ngOnInit() {
    this.record = this.data['record'];
    this.doctorObject = this.data['doctor'];
    this.procedureObject = this.data['procedure'];
    this.specialtyObject = this.data['specialty'];
    this.contratList = this.data['contract'];
    this.patientObject = this.data['patient'];
    this.productList = this.data['product'];
    this.productObject = this.data['productObject'];
    this.placesList = this.data['places'];
    this.placesObject = this.data['placesObject'];
    this.warehousesList = this.data['warehouses'];
    this.warehousesObject = this.data['warehousesObject'];
    this.userWarehouse = this.data['userWarehouse'];
    this.userCustomParams = this.data['customParams'];
    this.contractItem = this.data['contract'];
    this.supplierList = this.data['supplier'];
    this.userObject = this.data['users'];
    this.contract = this.record['contract'];

    // ✅ FIX: Initialize both forms BEFORE any await calls.
    // Angular renders the template synchronously before the first await resumes,
    // so [formGroup] bindings would receive undefined and crash if forms are
    // built after an await.
    this.tagRfidForm = this.formBuilder.group({
      tagRfid: [null, rfidTagValidators()],
    });

    this.interventionForm = this.formBuilder.group({
      startHour:  [this.record['startHour']  ?? null, Validators.required],
      finishHour: [this.record['finishHour'] ?? null, Validators.required],
      comments:   [this.record['comments']   ?? null],
    });

    this.logoEmpresaBase64 = LOGO_TECHMEDEVOLUTION;
    this.logoClinicaBase64 = LOGO_THECLINIC;

    if (!Array.isArray(this.contract)) {
      this.contract = this.contract ? [this.contract] : [];
    }

    this.itemList = this.contractItem.flatMap(element => {
      let tempLoop = element['products'].map(obj => ({
        contract:        element['id'],
        itemNumber:      obj['itemNumber'],
        itemDescription: obj['itemDescription']
      }));
      return tempLoop;
    });

    const categories = ['products', 'equipments', 'medicines', 'instrumentals'];
    const request = this.record['request'];

    for (const cat of categories) {
      if (request?.[cat] && Array.isArray(request[cat]) && request[cat].length > 0) {
        request[cat].forEach((item: any) => {
          item.consumption = 0;
          item.refund      = 0;
        });
      } else {
        if (request && !request[cat]) {
          request[cat] = [];
        }
      }

      if (
        this.record[cat]?.['delivery'] &&
        Array.isArray(this.record[cat]['delivery']) &&
        this.record[cat]['delivery'].length > 0
      ) {
        for (const itemId of this.record[cat]['delivery']) {
          const item = await this.getItemById(cat, itemId);
          if (item) {
            this.consumption.push(item);
            this._updateCategoryTable(cat, item);
          }
        }
      }
    }

    this.dataSource = new MatTableDataSource([]);
    this.buildCategoryTables();
  }

  buildCategoryTables() {
    this.categoryTables = [];
    const categories = ['products', 'equipments', 'medicines', 'instrumentals'];
    const request = this.record['request'];

    if (request != null && typeof request === 'object') {
      for (const category of categories) {
        if (Array.isArray(request[category]) && request[category].length > 0) {
          this.categoryTables.push({
            key:        category,
            label:      this.categoryLabels[category] || category,
            dataSource: new MatTableDataSource(request[category])
          });
        }
      }
    }
  }

  private _updateCategoryTable(category: string, item: any) {
    const request = this.record['request'];
    const requestItems: any[] = request?.[category] ?? [];

    const matchIndex = requestItems.findIndex((r: any) => r.itemCode === item['name']);

    if (matchIndex !== -1) {
      requestItems[matchIndex].consumption = (requestItems[matchIndex].consumption || 0) + 1;
    } else {
      requestItems.push({
        itemCode:        item['name'],
        itemDescription: item['description'],
        quantity:        0,
        delivery:        0,
        consumption:     1,
        refund:          0,
        type:            'bcc'
      });
      if (request && !request[category]) {
        request[category] = requestItems;
      }
    }

    const tableEntry = this.categoryTables.find(t => t.key === category);
    if (tableEntry) {
      tableEntry.dataSource.data = [...requestItems];
    } else {
      this.categoryTables.push({
        key:        category,
        label:      this.categoryLabels[category] || category,
        dataSource: new MatTableDataSource([...requestItems])
      });
    }
  }

  private _removeFromCategoryTable(category: string, item: any, type: 'consumo' | 'devolucion') {
    const request = this.record['request'];
    const requestItems: any[] = request?.[category] ?? [];

    const matchIndex = requestItems.findIndex((r: any) => r.itemCode === item['name']);

    if (matchIndex !== -1) {
      if (type === 'consumo') {
        requestItems[matchIndex].consumption = (requestItems[matchIndex].consumption || 1) - 1;
        requestItems[matchIndex].refund      = (requestItems[matchIndex].refund      || 0) + 1;
        if (requestItems[matchIndex].type === 'bcc' && requestItems[matchIndex].consumption <= 0 && requestItems[matchIndex].refund <= 0) {
          requestItems.splice(matchIndex, 1);
        }
      } else if (type === 'devolucion') {
        requestItems[matchIndex].refund      = (requestItems[matchIndex].refund      || 1) - 1;
        requestItems[matchIndex].consumption = (requestItems[matchIndex].consumption || 0) + 1;
      }
    }

    const tableEntry = this.categoryTables.find(t => t.key === category);
    if (tableEntry) {
      tableEntry.dataSource.data = [...requestItems];
    }
  }

  public formatDate(dateString: string): string {
    const testDate = new Date(dateString);
    return testDate.toLocaleDateString('es-ES', {
      day:    '2-digit',
      month:  'long',
      year:   'numeric',
      hour:   'numeric',
      minute: 'numeric',
    });
  }

  async getItemByTagRfid() {
    const tagRfid = String(this.tagRfidForm.value['tagRfid'] ?? '').trim().toUpperCase();
    if (!isValidRfidTag(tagRfid)) {
      await this.customMessageService.open({ title: 'Etiqueta inválida', type: 'warning', message: RFID_TAG_ERROR, dismissBtn: true });
      return;
    }
    const item    = this.consumption.find(x => x.tagRfid === tagRfid);

    if (!item) {
      await this.customMessageService.open({
        title:      'Información',
        type:       'neutral',
        message:    `Este insumo <b>${tagRfid}</b> no se encuentra en la lista de consumidos.`,
        dismissBtn: true,
      });
      return;
    }

    let response = await this.customMessageService.open({
      title:         'Información',
      type:          'neutral',
      message:       `Esta de acuerdo en remover el insumo con etiqueta ${tagRfid} de la lista de consumo.`,
      dismissBtn:    true,
      acceptBtn:     true,
      acceptBtnText: 'Continuar'
    });
    if (!response) return;

    this.refund      = [...this.refund, item];
    this.consumption = this.consumption.filter(x => x.tagRfid !== tagRfid);

    if (item['category']) {
      this._removeFromCategoryTable(item['category'], item, 'consumo');
    }

    this.tagRfidForm.controls['tagRfid'].reset();
  }

  async getItemById(cat: string, itemId: string): Promise<any | null> {
      switch (cat) {
        case 'products': {
          let productResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (productResponse.state === 'success' && productResponse.data[0]) {
            let item = productResponse.data[0];
            item['codeName']            = this.productObject[item['product']]['code'];
            item['codeDescription']     = this.productObject[item['product']]['description'];
            item['codeUsageFactor']     = this.productObject[item['product']]['usageFactor'];
            item['name']        = item['codeName'];
            item['description'] = item['codeDescription'];
            item['category']    = cat;
            return item;
          }
          return null;
        }
        case 'equipments': {
          let equipmentResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (equipmentResponse.state === 'success' && equipmentResponse.data[0]) {
            let item = equipmentResponse.data[0];
            item['name']        = this.productObject[item['product']]['code'];
            item['description'] = this.productObject[item['product']]['description'];
            return item;
          }
          return null;
        }
        case 'medicines': {
          let medicineResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (medicineResponse.state === 'success' && medicineResponse.data[0]) {
            let item = medicineResponse.data[0];
            item['name']        = this.productObject[item['product']]['code'];
            item['description'] = this.productObject[item['product']]['description'];
            return item;
          }
          return null;
        }
        case 'instrumentals': {
          let instrumentalResponse = await this.inventoryService.search({ searchType: 'default', condition: { id: itemId } });
          if (instrumentalResponse.state === 'success' && instrumentalResponse.data[0]) {
            let item = instrumentalResponse.data[0];
            item['name']        = this.productObject[item['product']]['code'];
            item['description'] = this.productObject[item['product']]['description'];
            return item;
          }
          return null;
        }
        default:
          return null;
      }
  }

  async deleteItem(item: any, type: string) {
    let response = await this.customMessageService.open({
      title:         'Información',
      type:          'neutral',
      message:       `Esta de acuerdo en remover el insumo con etiqueta ${item.tagRfid} de la lista de ${type}.`,
      dismissBtn:    true,
      acceptBtn:     true,
      acceptBtnText: 'Continuar'
    });
    if (!response) return;

    const category = item['category'];

    if (type === 'consumo') {
      this.refund.push(item);
      this.consumption = this.consumption.filter(x => x.id !== item.id);
      if (category) this._removeFromCategoryTable(category, item, 'consumo');
    } else if (type === 'devolucion') {
      this.consumption.push(item);
      this.refund = this.refund.filter(x => x.id !== item.id);
      if (category) this._removeFromCategoryTable(category, item, 'devolucion');
    }
  }

  updateRow(index: number, property: string, event: any) {
    const data = this.dataSource.data;
    if (property == 'quantity') {
      data[index][property] = Number(event.target.value);
    } else {
      data[index][property] = event.target.value;
    }
    this.dataSource.data = data;
  }

  async deleteRow(index: number) {
    const data = this.dataSource.data;
    let response = await this.customMessageService.open({
      title:         'Información',
      type:          'neutral',
      message:       `Esta de acuerdo en remover la partida ${data.at(index).itemNumber}  ${data.at(index).itemDescription} de la solicitud de material.`,
      dismissBtn:    true,
      acceptBtn:     true,
      acceptBtnText: 'Continuar'
    });
    if (!response) return;
    data.splice(index, 1);
    this.dataSource = new MatTableDataSource(data);
  }

  async save() {
    let data = this.interventionForm.value;

    log.debug('save data',data)
    const categories = ['products', 'equipments', 'medicines', 'instrumentals'];

    for (const cat of categories) {
      const consumptionIds = this.consumption.filter(item => item['category'] === cat).map(item => item.id);
      const refundIds      = this.refund.filter(item => item['category'] === cat).map(item => item.id);
      const deliveryIds = this.record?.[cat]?.delivery ?? [];

      data[cat] = {
        consumption: consumptionIds,
        refund: refundIds,
        delivery: deliveryIds
      };
    }

    data.personal ??= {};
    data.personal.medicalTechnician = {
      ...this.getTimestampRecord(),
      user: sessionStorage.getItem('userId')
    };

    data['status']               = 'Realizada';
    data['id']                   = this.record['id'];
    data['request']              = this.record['request'];

    for (const cat of categories) {
      const consumptionItems = this.consumption.filter(item => item['category'] === cat);
      const refundItems      = this.refund.filter(item => item['category'] === cat);

      if (consumptionItems.length > 0) await this.changeProductStatus(consumptionItems, 'Consumido', cat);
      if (refundItems.length > 0)      await this.changeProductStatus(refundItems, 'Disponible', cat);
    }

    let intervention = await this.pacthInterventions(data);
    if (!intervention) return;
    await this.generatePdf({ ...intervention });
    this.dialogRef.close(intervention);
  }

  async pacthInterventions(data: any) {
    this.customMessageService.open({
      title:    'Espere',
      type:     'neutral',
      message:  'Guardando programación quirúrgica',
      duration: 2000,
      loading:  true,
    });
    if (this.interventionForm.status == 'INVALID') {
      await this.customMessageService.open({
        title:      'Información',
        type:       'neutral',
        message:    'Por favor completa todos los campos del registro para editar la programación quirúrgica.',
        dismissBtn: true,
      });
      return false;
    }
    data['modifiedBy'] = sessionStorage.getItem('userId');
    data['operationType'] = 'single';
    let apiResponse = await this.interventionsService.update(data);
    this.customMessageService.close();
    if (apiResponse['state'] == 'success') {
      await this.customMessageService.open({
        title:    '¡Hecho!',
        type:     'success',
        message:  apiResponse['message'],
        duration: 2000,
      });
      return apiResponse['data'][0];
    } else {
      await this.customMessageService.open({
        title:   'Error',
        type:    'error',
        message: apiResponse['message'],
        duration: 2000,
      });
    }
  }

  async changeProductStatus(data: any[], status: string, category: string) {
    try {
      let updated = [];

      this.customMessageService.open({
        title:   'Espere',
        type:    'success',
        message: `Actualizando estatus de insumos...`,
        loading: true
      });

      for (const item of data) {
        if (!item || !item.id || !item.tagRfid) {
          console.warn('Item inválido encontrado:', item);
          continue;
        }

        let itemToUpdate: any = {
          id:         item['id'],
          tagRfid:    item['tagRfid'],
          status:     status,
          numberUses: item['numberUses'] || 0,
          warehouse:  item['warehouse'],
          operationType: 'single'
        };

        if (status === 'Consumido') {
          itemToUpdate.numberUses = itemToUpdate.numberUses + 1;

          const usageFactor = item['codeUsageFactor'] || 1;
          if (usageFactor > itemToUpdate.numberUses) {
            itemToUpdate.status  = 'Disponible';
          } else {
            itemToUpdate.status  = 'Consumido';
          }
        } else if (status === 'Disponible') {
          try {
            const apiResponseInterventions = await this.interventionsService.search({searchType:'default',
              consumption: [itemToUpdate.id]
            });

            if (
              apiResponseInterventions['state'] === 'success' &&
              apiResponseInterventions['data'] &&
              apiResponseInterventions['data'].length > 0
            ) {
              itemToUpdate.status  = item['status'];
            } else {
              itemToUpdate.status  = 'Disponible';
            }
          } catch (interventionError) {
            console.error('Error verificando intervenciones:', interventionError);
            itemToUpdate.status  = 'Disponible';
            itemToUpdate.inStock = true;
            const aduanaWarehouse = this.warehousesList.find(obj => obj['name'] === 'Aduana');
            if (aduanaWarehouse) itemToUpdate.warehouse = aduanaWarehouse['id'];
          }
        }

        try {
          let apiResponse: any;
          switch (category) {
            case 'products':
            case 'equipments':
            case 'medicines':
            case 'instrumentals':
            default:
              apiResponse = await this.inventoryService.update(itemToUpdate);
              break;
          }

          if (apiResponse['state'] === 'success') {
            const updatedRow = apiResponse['data'][0];
            updated.push(updatedRow);
            console.log(`Producto ${item.tagRfid} actualizado correctamente`);
          } else {
            console.error(`Error actualizando producto ${item.tagRfid}:`, apiResponse['message']);
            await this.customMessageService.open({
              title:      'Error',
              type:       'error',
              message:    `Error actualizando insumo ${item.tagRfid}: ${apiResponse['message']}`,
              dismissBtn: true
            });
          }
        } catch (updateError) {
          console.error(`Error en patchStock para ${item.tagRfid}:`, updateError);
          await this.customMessageService.open({
            title:      'Error',
            type:       'error',
            message:    `Error actualizando insumo ${item.tagRfid}`,
            dismissBtn: true
          });
        }
      }

      this.customMessageService.close();

      if (updated.length > 0) {
        await this.customMessageService.open({
          title:    '¡Hecho!',
          type:     'success',
          message:  `${updated.length} insumo(s) actualizado(s) correctamente`,
          duration: 3000
        });
      } else if (data.length > 0) {
        await this.customMessageService.open({
          title:      'Advertencia',
          type:       'warning',
          message:    'No se pudo actualizar ningún insumo',
          dismissBtn: true
        });
      }

      return updated;

    } catch (err) {
      this.customMessageService.close();
      console.error('Error en changeProductStatus:', err);
      await this.customMessageService.open({
        title:      'Error',
        type:       'error',
        message:    `Error general actualizando insumos: ${err}`,
        dismissBtn: true
      });
      throw err;
    }
  }

  public async generatePdf(pdfData: any) {
    try {
      log.debug('generatePdf pdfData',pdfData)
      this.customMessageService.open({ title: "Espere", type: 'success', message: 'Descargando boleta de intervención', loading: true, duration: 2000 });
      await this.downloadPDF(pdfData);
      this.customMessageService.close();
    } catch (error) {
      console.error("ERROR PDF: ", error);
      await this.customMessageService.open({
        title:    'Error',
        type:     'error',
        message:  'No fue posible generar el PDF',
        duration: 2000,
      });
    }
  }

  async downloadPDF(data: any) {
    this.customMessageService.open({
      title:    'Espere',
      type:     'success',
      message:  'Descargando boleta de programación quirúrgica',
      loading:  true,
      duration: 2000,
    });

    let info                       = { ...data };
    info['doctor']                 = this.doctorObject[info['doctor']];
    info['procedure']              = this.procedureObject[info['procedure']];
    info['specialty']              = this.specialtyObject[info['specialty']];

    const tecnico = info['personal']?.medicalTechnician?.user
      ? this.userObject[info['personal'].medicalTechnician.user]
      : '';

    const items = (info['request']?.products ?? []).map((item: any) => {
      const producto = this.productObject[item.itemCode];
      return {
        CODIGO:       item.itemCode,
        DESCRIPCION:  item.itemDescription,
        CANT_SOL:     item.quantity,
        INS_UTIL:     item.consumption,
        PRECIO: item.type === 'BCB'
          ? '$ 0.00'
          : producto?.price
              ? `$ ${Number(producto.price).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`
              : '$ 0.00',
      };
    });

    const reporteData: ReporteCxData = {
      unidadMedica:    this.placesObject[info['hospital']]        ?? '',
      fechaSolicitud:  this.formatDate(info['createdOn'])         ?? '',
      nombrePaciente:  this.patientObject[info['patient']]?.name ?? '',
      diagnostico:     info['diagnosis'] ? info['diagnosis']:'',
      aseguradora:     info['insurer'] ? info['insurer']:'',
      fechaCx:         this.formatDate(info['interventionDatetime']),
      procedimiento:   info['procedure']                         ?? '',
      folio:           info['fileNumber']                        ?? '',
      edad:            this.patientObject[info['patient']]?.birthDate ? this.calculateAgeAtDate(this.patientObject[info['patient']]?.birthDate,info['interventionDatetime']):'',
      especialidad:    info['specialty']                         ?? '',
      horaInicio:      this.formatTime(info['startHour']),
      horaTermino:     this.formatTime(info['finishHour']),
      medico:          info['doctor']                            ?? '',
      tecnico,
      items,
    };

    const config = this.buildReporteCxConfig(reporteData);
    await this.simplePdfService.simplePDF(config);

    this.customMessageService.close();
  }

  private formatTime(datetimeStr: string): string {
    if (!datetimeStr) return '';
    const date = new Date(datetimeStr);
    return date.toLocaleTimeString('es-MX', {
      hour:   'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  }

  async getUsersById(userId: string) {
    let httpResponse: any = await this.usersService.getUsersById({ id: userId });
    return httpResponse['data'];
  }

  private getTimestampRecord(){
    const now = new Date();
    return {
      date:      now.toLocaleDateString('es-ES'),
      time:      now.toLocaleTimeString('es-ES', { hour12: false }),
      timestamp: now.getTime()
    };
  }

  /**
   * Calculates the age of a person on a specific reference date.
   * @param {string|Date} birthDate - The person's date of birth.
   * @param {string|Date} referenceDate - The specific date to check the age on.
   * @returns {string|null} The age in years, or null if the reference date is before birth.
   */
  private calculateAgeAtDate(birthDate, referenceDate) {
      const birth = new Date(birthDate);
      const target = new Date(referenceDate);

      // Safety check: Is the target date before they were even born?
      if (target < birth) return null;

      let age = target.getFullYear() - birth.getFullYear();
      const monthDiff = target.getMonth() - birth.getMonth();

      // Check if the birthday has occurred yet in the target year
      if (monthDiff < 0 || (monthDiff === 0 && target.getDate() < birth.getDate())) {
          age--;
      }

      return String(age);
  }



  private buildReporteCxConfig(data: ReporteCxData): SimplePdfModel {

    const total = data.items.reduce((sum, item) => {
      const num = parseFloat(String(item.PRECIO).replace(/[$,]/g, '')) || 0;
      return sum + num;
    }, 0);
    const totalFormateado = `$ ${total.toLocaleString('es-MX', { minimumFractionDigits: 2 })}`;

    return {
      fileName: `REPORTE_CX_${data.folio}`,
      pageSize: 'A4',
      pageOrientation: 'portrait',
      pageMargins: [30, 30, 30, 50],
      defaultStyle: {
        fontSize: 9,
      },

      sections: [
        {
          type: 'table',
          table: {
            showBorders: false,
            showHeader:  false,
            columns: [
              { header: 'logoEmpresa', field: 'logoEmpresa', width: '*', alignment: 'left',  isImage: true, imageWidth: 120 },
              { header: 'logoClinica', field: 'logoClinica', width: '*', alignment: 'right', isImage: true, imageWidth: 120 },
            ],
            data: [
              { logoEmpresa: this.logoEmpresaBase64, logoClinica: this.logoClinicaBase64 }
            ],
          },
        },

        {
          type: 'text',
          text: 'FORMATO DE SOLICITUD Y CONSUMO DE SERVICIO E INSUMOS',
          textStyle: {
            fontSize: 13,
            bold: true,
            alignment: 'center',
            margin: [0, 0, 0, 12],
          },
        },

        {
          type: 'table',
          table: {
            showBorders: false,
            showHeader:  false,
            columns: [
              { header: 'labelIzq', field: 'labelIzq', width: 120, alignment: 'left'  },
              { header: 'valorIzq', field: 'valorIzq', width: '*', alignment: 'left'  },
              { header: 'labelDer', field: 'labelDer', width: 90,  alignment: 'left'  },
              { header: 'valorDer', field: 'valorDer', width: 100, alignment: 'left'  },
            ],
            data: [
              { labelIzq: 'UNIDAD MÉDICA',           valorIzq: data.unidadMedica,   labelDer: 'FOLIO',        valorDer: data.folio        },
              { labelIzq: 'FECHA DE SOLICITUD',       valorIzq: data.fechaSolicitud, labelDer: 'EDAD',         valorDer: data.edad         },
              { labelIzq: 'NOMBRE DEL PACIENTE',      valorIzq: data.nombrePaciente, labelDer: '',             valorDer: ''                },
              { labelIzq: 'DIAGNÓSTICO',              valorIzq: data.diagnostico,    labelDer: '',             valorDer: ''                },
              { labelIzq: 'ASEGURADORA',              valorIzq: data.aseguradora,    labelDer: 'ESPECIALIDAD', valorDer: data.especialidad  },
              { labelIzq: 'FECHA DE CX',              valorIzq: data.fechaCx,        labelDer: 'HORA INICIO',  valorDer: data.horaInicio   },
              { labelIzq: 'PROCEDIMIENTO A REALIZAR', valorIzq: data.procedimiento,  labelDer: 'HORA TÉRMINO', valorDer: data.horaTermino  },
            ],
          },
        },

        {
          type: 'lineBreak',
          lineBreak: 1,
        },

        {
          type: 'table',
          table: {
            title: 'DETALLE DE INSUMOS',
            showBorders: true,
            headerStyle: {
              fillColor: '#170f5f',
              textColor: '#ffffff',
              bold: true,
            },
            columns: [
              { header: 'CODIGO',      field: 'CODIGO',      width: 80,  alignment: 'center' },
              { header: 'DESCRIPCION', field: 'DESCRIPCION', width: '*', alignment: 'left'   },
              { header: 'CANT.SOL',    field: 'CANT_SOL',    width: 55,  alignment: 'center' },
              { header: 'INS.UTIL',    field: 'INS_UTIL',    width: 55,  alignment: 'center' },
              { header: 'PRECIO',      field: 'PRECIO',      width: 70,  alignment: 'right'  },
            ],
            data: data.items,
          },
        },

        {
          type: 'lineBreak',
          lineBreak: 1,
        },
        {
          type: 'text',
          text: `TOTAL:   ${totalFormateado}`,
          textStyle: {
            fontSize: 11,
            bold: true,
            alignment: 'right',
            margin: [0, 0, 0, 20],
          },
        },

        {
          type: 'table',
          table: {
            showBorders: false,
            columns: [
              { header: ' ',  width: '*', alignment: 'center' },
              { header: '  ', width: '*', alignment: 'center' },
            ],
            data: [
              { ' ': '___________________________', '  ': '___________________________' },
              { ' ': data.medico,                  '  ': data.tecnico                  },
              { ' ': 'NOMBRE Y FIRMA DEL MÉDICO ESPECIALISTA', '  ': 'NOMBRE Y FIRMA DEL TÉCNICO' },
            ],
          },
        },
      ],

      footer: {
        showPageNumbers: true,
        customText: 'Formato de Solicitud y Consumo de Servicio e Insumos',
        alignment: 'center',
      },
    };
  }

}